import styled from "styled-components"

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  .loader-icon {
    animation: rotate 0.6s linear infinite;
    transform-origin: center center;
  }
`
